import { styles, SkeletonTheme } from '../SkeletonStyles.css';
import { baseTheme } from './SkeletonBaseTheme.css';
import { multiVariantStyles } from './SkeletonVariants.css';

const SkeletonRedwoodTheme: SkeletonTheme = {
  baseTheme,
  multiVariantStyles,
  styles
};

/*******************
 * Exports
 *******************/

export { SkeletonRedwoodTheme };
